import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const placeHoldersReducer = (
  state = initialState.placeHolder,
  action
) => {
  switch (action.type) {
    case types.GET_PLACE_HOLDERS_SUCCESS:
      return state.concat(action.payload);

    case types.GET_PLACE_HOLDERS_FAILED:
      return state;

    default:
      return state;
  }
};

export const analyticsPlaceHoldersReducer = (
  state = initialState.analyticsPlaceHolders,
  action
) => {
  switch (action.type) {
    case types.GET_ANALYTICS_PLACE_HOLDERS_SUCCESS: {
      if (action.payload && action.payload.data) {
        let headerAnalytics = action.payload.data.find(
          data => data.section == "Header"
        );
        let bodyAnalytics = action.payload.data.find(
          data => data.section == "Body"
        );
        appendAnalyticsToHeader(headerAnalytics && headerAnalytics.content);
        appendAnalyticsToBody(bodyAnalytics && bodyAnalytics.content);
      }
      return {
        phase: action.payload.phase,
        code: action.payload.content
      };
    }

    case types.GET_ANALYTICS_PLACE_HOLDERS_FAILED:
      return state;

    case types.CLEAR_ANALYTICS_PLACE_HOLDERS: {
      return {};
    }

    default:
      return state;
  }
};

async function appendAnalyticsToBody(htmlCode) {
  //Habdle body analytics
  const wrapper = document.getElementById(`page-analytics-wrapper-Body`);
  if (!wrapper) return;
  wrapper.innerHTML = "";
  let doc = document.implementation.createHTMLDocument();
  doc.body.innerHTML = htmlCode;
  let allScriptsTag = doc.getElementsByTagName("script");

  Array.from(allScriptsTag).forEach(s => {
    let scriptElem = document.createElement("script");

    const scriptBody = document.createTextNode(s.innerText);
    if (s.src) {
      scriptElem.src = s.src;
    }
    if (s.async) {
      scriptElem.async = s.async;
    }
    scriptElem.appendChild(scriptBody);

    wrapper && wrapper.appendChild(scriptElem);
  });
}

async function appendAnalyticsToHeader(htmlCode) {
  if (htmlCode != "") {
    const doc = new DOMParser().parseFromString(htmlCode, "text/html");
    const elementToAppend = doc.head.firstElementChild;
    document.head.appendChild(elementToAppend);
  }
}

// const removeAnalyticsFromDOM = () => {
//   const wrapper = document.getElementById("page-analytics-wrapper");
//   if (!wrapper) return;
//   wrapper.innerHTML = "";
// };



// WEBPACK FOOTER //
// ./src/reducers/placeHoldersReducer.js